import { IndicatorProps } from "react-select";
import { ReactComponent as ArrowUp } from "../../../assets/icons/arrow-up.svg";
import { ReactComponent as ArrowDown } from "../../../assets/icons/arrow-down.svg";

const DropdownIndicator = ({ selectProps }: IndicatorProps<any, boolean>) => (
  selectProps.menuIsOpen ? <ArrowUp /> : <ArrowDown />
);

export default DropdownIndicator;